import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import Typography from 'material-ui/Typography';
import NumberFormat from 'react-number-format';
import Card, {
    CardContent,
    CardActions,
} from 'material-ui/Card';
import colors from '../../../../config/themeColors';
import WhiteButton from '../../../common/components/Buttons/WhiteButton';

const styles = ({ spacing: { unit } }) => ({
    root: {
        width: '100%',
        marginTop: unit * 2,
    },
    button: {
        marginLeft: unit * 2,
    },
    buttons: {
        marginTop: unit * 2,
        marginBottom: unit * 2,
    },
    formControl: {
        marginTop: unit * 3,
        minWidth: unit * 26,
        '&:not(:last-of-type)': {
            marginRight: unit * 3,
        },
    },
    propertyContainer: {
        backgroundColor: colors.white,
        width: '100%',
        borderRadius: '4px',
        boxShadow: '0 0 8px 0 rgba(0, 0, 0, 0.12)',
    },
    divider: {
        margin: 0,
        display: 'block',
        height: '1px',
        border: 0,
        borderTop: `1px solid ${colors.white2}`,
        padding: '0',
    },
    photo: {
        maxWidth: '100%',
        borderTopLeftRadius: '4px',
        borderTopRightRadius: '4px',
    },
    textContainer: {
        padding: '16px',
    },
    card: {
        boxSizing: 'border-box',
        padding: 0,
        borderRadius: '4px',
        boxShadow: '0 0 8px 0 rgba(0, 0, 0, 0.12)',
    },
    cardSelected: {
        border: `3px solid ${colors.bloodOrange}`,
    },
    cardContent: {
        padding: 0,
    },
    cardActions: {
        height: 'auto',
        padding: '16px',
        justifyContent: 'center',
        backgroundColor: colors.white3,
    },
    street: {
        marginTop: '16px',
    },
});

function PropertyDetails(props) {
    const selected = props.selectedProperty.propertyId === props.property.propertyId ? props.classes.cardSelected : '';
    return (
        <Card className={[props.classes.card, selected].join(' ')}>
            <CardContent className={props.classes.cardContent}>
                <img
                    src={props.property.photo}
                    alt=""
                    className={props.classes.photo}
                />

                <div className={props.classes.textContainer}>
                    <Typography variant="subheading">
                        <NumberFormat
                            value={props.property.value.estaminatedPropertyValue.amount}
                            displayType="text"
                            thousandSeparator
                            prefix="&pound;"
                        />
                    </Typography>
                    <Typography variant="caption">
                        Estimated Value
                    </Typography>
                    <Typography variant="subheading" className={props.classes.street}>
                        {props.property.address.street} {props.property.address.houseNumber} {props.property.address.postalCode} {props.property.address.city}
                    </Typography>
                    <Typography variant="caption">
                        Address
                    </Typography>
                </div>
                <hr className={props.classes.divider} />
                <div className={props.classes.textContainer}>
                    <Typography variant="subheading">
                        <NumberFormat
                            value={props.property.value.estaminatedPropertyMonthlyRent.amount}
                            displayType="text"
                            thousandSeparator
                            prefix="&pound;"
                        />
                    </Typography>
                    <Typography variant="caption">
                        Estimated Mo. Rental Income
                    </Typography>
                </div>
            </CardContent>
            <CardActions className={props.classes.cardActions}>
                <WhiteButton
                    isSelected={props.selectedProperty.propertyId === props.property.propertyId}
                    color="secondary"
                    onClick={() => {
                        props.selectProperty(props.property);
                    }}
                >
                    select
                </WhiteButton>
            </CardActions>
        </Card>
    );
}

PropertyDetails.propTypes = {
    classes: PropTypes.object.isRequired,
    property: PropTypes.object.isRequired,
    selectProperty: PropTypes.func.isRequired,
    selectedProperty: PropTypes.object.isRequired,
};

export default withStyles(styles)(PropertyDetails);



// WEBPACK FOOTER //
// ./src/app/FormStepper/PropertyDetails/components/PropertyItem.js